import toggleClass from './utils/toggleClass'
import UI from './utils/UI'
import { TweenMax } from 'gsap'

UI({
  component: '.js-productStores',
  allStoresContainer: '.js-productStoresAllStoresContainer',
  button: '.js-productStoresButton',
  word: '.js-productStoresWord',
  stores: ['.js-productStores-store']
}, ({ component, allStoresContainer, button, word, stores }) => {
  stores.forEach(store => store.addEventListener('click', _ => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'shopClicked', shopName: store.getAttribute('title') })
  }))
  if (!button) {
    return
  }

  let contentIsClosed = false

  button.addEventListener('click', evt => {
    evt.preventDefault()
    button.blur()

    toggleClass(button, 'is-closed', contentIsClosed)

    if (!contentIsClosed) {
      open()
    } else {
      close()
    }

    word.innerHTML = contentIsClosed ? window.ftoL10n.showLabel : window.ftoL10n.hideLabel

    contentIsClosed = !contentIsClosed
  })

  function open () {
    allStoresContainer.style.height = 'auto'
    TweenMax.fromTo(allStoresContainer, 0.2, { height: 0 }, { height: allStoresContainer.clientHeight, onComplete: () => { allStoresContainer.style.height = 'auto' } })
  }

  function close () {
    TweenMax.to(allStoresContainer, 0.2, { height: 0 })
  }
})
